import { initializeApp } from 'firebase/app';
import { getAnalytics,logEvent } from "firebase/analytics";
import { getDatabase, ref, set, child, get, query, orderByChild, limitToLast, update } from "firebase/database";

import { initializeAppCheck, ReCaptchaV3Provider } from "firebase/app-check";

const firebaseConfig = {
    apiKey: "AIzaSyC4_98nm6zJMw1NQM0KYM0CPVXcAaOtUmo",
    authDomain: "rhb-games.firebaseapp.com",
    databaseURL: "https://rhb-games-default-rtdb.asia-southeast1.firebasedatabase.app",
    projectId: "rhb-games",
    storageBucket: "rhb-games.appspot.com",
    messagingSenderId: "578603109286",
    appId: "1:578603109286:web:e88fa589ae15abaed41d67",
    measurementId: "G-320KH0ZZ91"

    
};


var firebaseApp = initializeApp(firebaseConfig);

const appCheck = initializeAppCheck(firebaseApp, {
    provider: new ReCaptchaV3Provider('6Ld83OQjAAAAAOe0sh-HkF-InSHsCaMf39ebxt5k'),
  
    // Optional argument. If true, the SDK automatically refreshes App Check
    // tokens as needed.
    isTokenAutoRefreshEnabled: true
  });
  const analytics = getAnalytics();
  logEvent(analytics, 'notification_received');
export { firebaseApp, getDatabase, ref, set, child, get, query, orderByChild, limitToLast, update }